<div class="ui basic segment">
  <div *ngIf="success || error">
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <div
    style="margin: -5px -30px"
    class="ui vertical basic segment"
    [ngClass]="{}"
  >
    <app-advanced-search-filter
      [filter]="filter"
      (onSearch)="searchRecords($event)"
      (onDisplayRows)="displayRecords($event)"
      (onSort)="sortRecords($event)"
      [hasFilters]="false"
      [hasAdvancedSearch]="false"
    ></app-advanced-search-filter>
  </div>
  <div
    style="margin: -8px -30px"
    class="ui vertical basic segment"
    [ngClass]="{ loading: pending }"
  >
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <div fxFlex="75%">Geofence Location</div>
      <!-- <div fxFlex="25%">Enable</div> -->
      <div fxFlex="5"></div>
      <!-- <div fxFlex="20%">Actions</div> -->
    </div>
    <ng-container *ngFor="let location of locations">
      <div
        class="ui segment"
        appMargin
        marginB="3"
        fxLayout="row"
        fxLayoutGap="10px"
        fxLayoutAlign="start stretch"
      >
        <div fxFlex="75%">{{ location.countryName }}</div>
        <!-- <div fxFlex="25%">
          <div class="ui fitted toggle checkbox">
            <input
              type="checkbox"
              [checked]="location.status == 'ALLOWED'"
              (change)="toggleLocation(location)"
            />
            <label></label>
          </div>
        </div> -->

        <div fxFlex="5%">
          <div
            *ngIf="
              checkPermission({
                id: 'APPLICATION_SECURITY_MODULE',
                action: 'remove'
              })
            "
            (click)="delete(location)"
            class="ui circular button"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.75 2.59375H10.9688V1.875C10.9688 0.841125 10.1276 0 9.09375 0H6.90625C5.87238 0 5.03125 0.841125 5.03125 1.875V2.59375H1.25C0.904813 2.59375 0.625 2.87356 0.625 3.21875C0.625 3.56394 0.904813 3.84375 1.25 3.84375H1.89725L2.65894 13.7183C2.65916 13.7212 2.65941 13.7241 2.65966 13.727C2.71641 14.3497 3.00197 14.9247 3.46372 15.3463C3.92547 15.7678 4.52409 16 5.14931 16H10.8507C12.1528 16 13.2231 15.0302 13.3403 13.7443C13.3717 13.4005 13.1184 13.0964 12.7747 13.0651C12.4306 13.0338 12.1268 13.287 12.0955 13.6307C12.0373 14.2688 11.5022 14.75 10.8507 14.75H5.14931C4.50003 14.75 3.96572 14.2634 3.90484 13.6174L3.15097 3.84375H12.849L12.3152 10.7644C12.2887 11.1086 12.5462 11.4091 12.8903 11.4357C12.9067 11.4369 12.9229 11.4375 12.9391 11.4375C13.2624 11.4375 13.5363 11.1883 13.5615 10.8606L14.1027 3.84375H14.75C15.0952 3.84375 15.375 3.56394 15.375 3.21875C15.375 2.87356 15.0952 2.59375 14.75 2.59375ZM9.71875 2.59375H6.28125V1.875C6.28125 1.53038 6.56163 1.25 6.90625 1.25H9.09375C9.43838 1.25 9.71875 1.53038 9.71875 1.875V2.59375Z"
                fill="#86879D"
              />
              <path
                d="M5.16017 5.09439C4.81533 5.10945 4.54798 5.4012 4.56305 5.74608L4.87555 12.9002C4.8902 13.2358 5.16686 13.498 5.49948 13.498C5.50867 13.498 5.51795 13.4978 5.52723 13.4974C5.87208 13.4823 6.13942 13.1905 6.12436 12.8457L5.81186 5.69148C5.79679 5.34667 5.50448 5.07889 5.16017 5.09439Z"
                fill="#86879D"
              />
              <path
                d="M10.1881 5.69148L9.87561 12.8457C9.86054 13.1905 10.1279 13.4823 10.4727 13.4973C10.482 13.4978 10.4913 13.498 10.5005 13.498C10.8331 13.498 11.1098 13.2358 11.1244 12.9002L11.4369 5.74607C11.452 5.40123 11.1846 5.10945 10.8398 5.09438C10.4955 5.07898 10.2032 5.34663 10.1881 5.69148Z"
                fill="#86879D"
              />
              <path
                d="M7.375 5.71875V12.8729C7.375 13.2181 7.65481 13.4979 8 13.4979C8.34519 13.4979 8.625 13.2181 8.625 12.8729V5.71875C8.625 5.37356 8.34519 5.09375 8 5.09375C7.65481 5.09375 7.375 5.37356 7.375 5.71875Z"
                fill="#86879D"
              />
            </svg>
          </div>
        </div>
      </div>
    </ng-container>
    <app-no-record-found
      *ngIf="locations && locations.length < 1"
    ></app-no-record-found>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon small button">
            <i class="database icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
